<template>
  <div class="home">
    <div class="home-logo">
      <img src="/logo.png" alt="LOGO">
    </div>
    <!-- <div class="chart-wrapper">
      <line-chart :height="150" :width="800" :chart-data="datacollection"></line-chart>
    </div> -->
  </div>
</template>

<script>

// import OffersService from '../api-services/offers.service.js'
// import LineChart from '../charts/LineChart.js'

export default {
  name: 'home',
  // components: {
  //   LineChart
  // },
  data () {
    return {
      datacollection: null,
      chartData: null
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    // OffersService.getChartStatsGeneral()
    //   .then((response) => {
    //     this.chartData = response.data
    //     this.fillData(this.chartData)
    //   })
  },
  mounted () {
  },
  methods: {
    // fillData (chartData) {
    //   this.datacollection = {
    //     labels: chartData.labels,
    //     datasets: []
    //   }
    //   for (var key in chartData.values) {
    //     this.datacollection.datasets.push({
    //       label: chartData.names[key],
    //       borderColor: chartData.colors[key],
    //       backgroundColor: chartData.colors[key],
    //       fill: false,
    //       data: chartData.values[key]
    //     })
    //   }
    // }
  }
}
</script>
